<template>
<div class="page page_fans">
    <!-- 有关注 -->
	<div class="" ref="vlist">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item_l" @click="goPage(item)">
						<img :src="item.tradesman_thumb ? ($publicData.withHttpStart(item.tradesman_thumb) ? item.tradesman_thumb : imageUrl+item.tradesman_thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
						<div class="user_name slh_s">{{ item.tradesman_name }}</div>
					</div>
					<div class="item_r">
						<div class="action guanzhu" @click="cancelGuan(item)">已关注</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
    <!-- 无关注 -->
    <div class="page_default" ref="default" style="display:none">
        <div class="bg">
            <img :src="publicPath+'statics/images/no_guanzhu.png'" alt="" class="tu">
        </div>
        <div class="tips">暂无关注</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
			dataList: [],
			loading: true,
			finished: false,
			pages: {
				page: 1,
				size: 10
			},
			list: [] // 转存数据
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '关注'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // this.getData()
                responseCallback({})
            })
        } else {
			this.token = this.$store.getters.token
			this.getData();
        }
        // 获取列表
        // this.getData();
    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            console.log(params)
            this.$api.my.attentionList(params).then(res => {
                if (res.code == 200) {
					var list = res.result
					// 判断第一页有没有数据
					// console.log('list',list)
					if(this.pages.page == 1 && list.length == 0){
						// 无数据
						$(this.$refs.vlist).css('display','none')
						$(this.$refs.default).css('display','block')
					}else{
						// 有数据
						if(list.length != 0){
							for(var i in list) {
								this.dataList.push(list[i])
							}
							// 分页加载
							this.pages.page++
							this.loading = false
						}else{
							// 加载完毕
							this.finished = true
						}
					}	
                } else {
					// 接口报错
					this.finished = true
                    this.$toast(res.message)
				}
            })
        },
        // 取消关注
        cancelGuan(item) {
			console.log(item)
			var params = {
				token: this.token,
				tradesman_id: item.tradesman_id,
				type: 2
			}
			this.$api.tradesman.attention(params).then(res => {
				if (res.code == 200) {
					console.log(res)
					this.$toast('取消关注成功')
					this.pages.page = 1
					this.dataList = []
					this.getData()
				}
			})
		},
		// 进入商家中心页
		goPage(item){
			this.$router.push({
				path: '/art/detail',
				query: {
					tradesmanId: item.tradesman_id
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
